import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IEnvironment,
    IRobot,
    ODataResponse,
} from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { ISelectionDiff } from '@uipath/angular/components/ui-grid';
import { ISuggestValues } from '@uipath/angular/components/ui-suggest';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class EnvironmentService extends ODataService<IEnvironment, number> {
    protected _endpoint = '/odata/Environments';
    constructor(http: HttpClient) {
        super(http, MapperService.environmentMap);
    }

    public getRobotsIn(environmentId: number, queryOptions?: ODataQueryOptions) {
        const environmentRobotsEndpoint =
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetRobotsForEnvironment(key=${environmentId})`;

        return this._http.get(`${environmentRobotsEndpoint}${this.getQueryString(queryOptions)}`)
            .pipe(
                map(res => this._mapData(res, MapperService.robotMap)),
            ) as Observable<ODataResponse<IRobot>>;
    }

    public getRobotIdsForEnvironment(environmentId: number) {
        return this._http.get<{ value: Array<number> }>(this._endpoint +
            `/UiPath.Server.Configuration.OData.GetRobotIdsForEnvironment(key=${environmentId})`)
            .pipe(
                map(data => data.value.map(id => ({ id }))),
            );
    }

    public setRobots(environmentId: number,
        { add, remove }: ISelectionDiff<IEnvironment>) {
        const payload = {
            addedRobotIds: add.map(e => e.id),
            removedRobotIds: remove.map(e => e.id),
        };

        return this._http.post(
            `${this._endpoint}(${environmentId})/UiPath.Server.Configuration.OData.SetRobots`,
            JSON.stringify(payload),
        );
    }

    public environmentNameSuggest = (
        searchTerm: string = '',
        fetchSize = 20,
        skip = 0,
    ): Observable<ISuggestValues<IEnvironment>> => {
        const queryOptions: ODataQueryOptions = {
            select: ['Id', 'Name'],
            orderBy: ['Name'],
            skip: skip,
            top: fetchSize,
            filter: {
                'Name': {
                    contains: searchTerm,
                },
            },
        };

        return this
            .get(queryOptions)
            .pipe(
                map(
                    res => ({
                        total: res.total,
                        data: res.data.map(
                            environment => ({
                                id: environment.id,
                                text: environment.name,
                            }),
                        ),
                    } as ISuggestValues<IEnvironment>),
                ),
            );
    }
}
